import { Card, CardContent } from "../ui/card";
import { Button } from "../ui/button";
import { Video, Calendar } from "lucide-react";
import { Link } from "wouter";
import { useSelector } from "react-redux";
import HasPermission from "../auth/HasPermission";

const WelcomeCard = () => {
  // Use the same user source as Header
  const user = useSelector((state) => state.me.me);

  const doctorName =
    user?.fullName ||
    user?.name ||
    `${user?.given_name || ""} ${user?.family_name || ""}`.trim() ||
    user?.given_name ||
    user?.email?.split("@")[0] ||
    "Doctor";

  return (
    <Card className="mb-6 overflow-hidden flex-1 w-full">
      {/* Header Section */}
      <div className="bg-blue-600 text-white p-6">
        <h1 className="text-2xl font-semibold">
          Welcome to Seismic Connect – Healthcare Intelligence Platform
        </h1>
        <p className="text-blue-100 mt-2">
          Hello {doctorName}, we are here to support the way you practice care
        </p>
      </div>

      {/* Body Section */}
      <CardContent className="p-6">
        <p className="text-neutral-700 text-base leading-relaxed">
          Seismic Connect delivers real-time clinical insights, streamlined workflows, and intelligent decision support so you can focus on delivering exceptional patient care.
        </p>

        {/* Buttons */}
        <div className="mt-6 flex flex-wrap gap-4">
          <HasPermission required="dashboard.view_appointments" level="read">
            <Link href="/appointments">
              <Button className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700">
                <Calendar className="h-4 w-4" />
                View Appointments
              </Button>
            </Link>
          </HasPermission>

          <HasPermission required="dashboard.start_video_call" level="write">
            <Link href="/video-call">
              <Button
                variant="outline"
                className="flex items-center gap-2 text-blue-600 border-blue-600 hover:bg-blue-50"
              >
                <Video className="h-4 w-4" />
                Start Video Call
              </Button>
            </Link>
          </HasPermission>
        </div>
      </CardContent>
    </Card>
  );
};

export default WelcomeCard;
